import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { fetchServCategoryXServCdRange, fetchServiceCategoryHistFact, fetchServiceCodeRangeFact, fetchServicesAll, fetchServiceTypeNames, fetchServices, fetchClaimFact, fetchClaimDetails, fetchDescribeLogGroups, fetchStartLiveTail, fetchLogEvents, fetchDescribeLogStreams } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import Select from 'react-select';


const limit = 20;

const searchOptions = ['logGroupNamePrefix', 'logGroupNamePattern'].map(str => ({ value: str, label: str }))


const LogGroups = ({ memberKey }) => {

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();

    const [searchBy, setSearchBy] = useState(null);

    const { ref, inView } = useInView();

    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["logs", limit, decouncedSearchValue, searchBy?.value],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};


            if (decouncedSearchValue && searchBy?.value) {
                params[searchBy?.value] = decouncedSearchValue;
            }

            return await fetchDescribeLogGroups({ ...params, limit });
        },

        select: (data) => {
            console.log({ data });
            return { nextToken: data.pages?.at(-1)?.nextToken, logGroups: data.pages.map((page) => page.logGroups).flatMap((x) => x) };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            const nextToken = lastPage.nextToken;

            if (!nextToken) return undefined;
            return {
                nextToken
            };
        },
        staleTime: 0,
        enabled: true
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const columns = ['logGroupName', 'retentionInDays', 'arn', 'storedBytes', 'creationTime'];

    const onDetailHandler = async (body) => {
        console.log(body)
        if (!body) return {}
        // const claimDetails = await fetchStartLiveTail({
        //     logGroupIdentifiers: [body.logGroupArn]
        // })

        const logStreams = await fetchDescribeLogStreams({
            logGroupName: body.logGroupName,
            descending: true,
            orderBy: 'LastEventTime'
        })

        return logStreams
    }

    return (
        <div className={'container '}
            style={memberKey ? { maxHeight: '100%', overflow: 'scroll' } : {}}
        >
            <p className='title'>Log Groups </p>
            <p className="sub-title">Aws cloudwatch logs</p>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    {<Select
                        name={'searchBy'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={'Search by'}
                        // inputRef={field.ref}
                        options={searchOptions}
                        value={searchBy} // Pass the state variable here
                        onChange={(option) => { setSearchBy(option) }}
                    // value={options.find((c) => c.value === field.value)}
                    // onChange={(val) => field.onChange(val.value)}
                    />}


                    {searchBy && <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />}

                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setSearchBy(null)
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>

            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"logs"}
                        columns={columns}
                        items={data?.logGroups}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onEditHandler={onEditHandler}
                        onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}

export default LogGroups